(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-tabs"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {

  // -----------------------------
  // Tab Functionality
  // -----------------------------
  const tabs = document.querySelectorAll('.custom-collection-tabs .tab');
  const panels = document.querySelectorAll('.custom-collection-tabs .tab-panel');

  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      tabs.forEach(t => t.classList.remove('active'));
      panels.forEach(p => p.classList.remove('active'));
      tab.classList.add('active');
      const handle = tab.getAttribute('data-collection-handle');
      const panel = document.getElementById(`collection-${handle}`);
      if (panel) panel.classList.add('active');
    });
  });

  // -----------------------------
  // FAST AJAX Add to Cart (SAVOR THEME)
  // -----------------------------
  function initAddToCartButtons() {
    const buttons = document.querySelectorAll('.add-to-cart-btn');

    buttons.forEach(btn => {
      const productId = btn.dataset.productId;
      if (!productId) return;

      btn.removeEventListener('click', btn._listener);

      const listener = function(e) {
        e.preventDefault();

        const originalHTML = btn.innerHTML;
        btn.disabled = true;

        // 🔥 *Instant* feedback
        btn.innerHTML = "Adding...";

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: productId, quantity: 1 })
        })
        .then(response => {
          if (!response.ok) throw new Error('Error adding');
          return response.json();
        })
        .then(() => {

          // Update Savor cart UI + drawer
          window.dispatchEvent(new CustomEvent('cart:refresh'));
          window.dispatchEvent(new CustomEvent('open-cart'));

          // ⚡ INSTANT success text (fast!)
          btn.innerHTML = `
            <svg width="18" height="18" viewBox="0 0 20 20" fill="none"
            xmlns="http://www.w3.org/2000/svg">
              <path d="M4.75 10.75L7.68 14.59C7.79 14.72 7.84 14.79 7.91 14.82C7.97 14.84 8.03 14.84 8.09 14.82C8.15 14.79 8.21 14.72 8.32 14.59L15.25 5.75"
              stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round"></path>
            </svg>
            Added
          `;

          // ⚡ QUICK RESET (600ms)
          setTimeout(() => {
            btn.innerHTML = originalHTML;
            btn.disabled = false;
          }, 600);
        })
        .catch(() => {
          alert("Could not add to cart");
          btn.innerHTML = originalHTML;
          btn.disabled = false;
        });
      };

      btn.addEventListener('click', listener);
      btn._listener = listener;
    });
  }

  initAddToCartButtons();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-testimonial-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    new Swiper('.testimonial-swiper', {
      slidesPerView: 1,
      loop: true,
      spaceBetween: 0,
      speed: 1000,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: false
    });
  }, 300);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
